import React from "react";
import { DocEntityMap, DocProps } from "../../Language";
import { LysaAsIntermediarySV as SV } from "./LysaAsIntermediarySV";
import "../../Documents.css";

const docsMap: DocEntityMap = { SV };

export const LysaAsIntermediary: React.FC<DocProps> = (props) =>
  React.createElement(docsMap[props.language], props);
